import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

// here we import our modules
import example from './modules/example'
import authentication from './modules/authentication'
import campaign from './modules/campaign'
import settings from './modules/settings'
import users from './modules/users'
import accounts from './modules/accounts'
import fund from './modules/fund'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  // here we add the application modules 'campaigns', 'profile', 'accounts', etc ...
  modules: {
    example,
    authentication,
    campaign,
    settings,
    users,
    accounts,
    fund
  },
  strict: process.env.NODE_ENV !== 'production'
})
